export const MENU = [
    {
        id: 1,
        name: '¿Por qué Kaizen?',
        url: '/motivo'
    },
    {
        id: 2,
        name: 'Soluciones',
        url: '/soluciones',
    },
    {
        id: 3,
        name: 'Metodología',
        url: '/metodologia',
    },
    {
        id: 4,
        name: 'Plataforma asesores',
        url: 'https://backoffice.capitalkaizen.com/'
    }
];